<template>
  <div class="z-info">
    <div class="container">
      <h2 class="info-title">{{title}}</h2>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    }
  }
};
</script>

<style lang="scss" scoped>
.z-info {
  padding: 36px 0 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  .info-title {
    margin-bottom: 10px;
    font-size: 22px;
    color: #222222;
  }
  .desc {
    font-size: 12px;
    color: #222222;
  }
}
</style>